import React, { useState, useEffect } from "react";
import { Modal, Button, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import { useInvoicing } from "../../../hooks";
import { printTicket } from "../../../utils/ticket";
import {
  subscribeIssuedDocument,
  closeIssuedDocument,
} from "../../../utils/issuedDocument";

// Se queda abierto hasta que el cajero elija: Imprimir, Descargar PDF o Listo
// (no se cierra con Escape ni tocando afuera). "Listo" cierra la mesa en
// pantalla (onDone) y recién ahí desaparece.
export function IssuedDocumentModal() {
  const [issued, setIssued] = useState(null);
  const { downloadComprobantePdf } = useInvoicing();

  useEffect(() => subscribeIssuedDocument(setIssued), []);

  if (!issued) return null;
  const { comprobante, orders, payment, issuer, siteName, onDone } = issued;

  const onPrint = () =>
    printTicket({
      siteName,
      orders,
      payment,
      kind: "pago",
      comprobante,
      issuer,
    });

  const onDownload = async () => {
    try {
      await downloadComprobantePdf(comprobante);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const onFinish = () => {
    closeIssuedDocument();
    if (onDone) onDone();
  };

  return (
    <Modal size="mini" open closeOnDimmerClick={false} closeOnEscape={false}>
      <Modal.Header>
        {comprobante.doc_type === "NOTA" ? "Nota de venta emitida" : "Comprobante emitido"}
      </Modal.Header>
      <Modal.Content>
        <p>
          <strong>{comprobante.doc_label}</strong>
          <br />
          {comprobante.full_number} · S/ {Number(comprobante.total).toFixed(2)}
        </p>
        {comprobante.is_test && (
          <p style={{ color: "#b58105" }}>
            <Icon name="warning sign" /> Documento de PRUEBA: simulado, sin validez tributaria.
          </p>
        )}
        <p style={{ color: "#777", fontSize: "0.9em" }}>
          Imprímelo o descárgalo; cuando termines pulsa <strong>Listo</strong> para continuar.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button basic onClick={onPrint}>
          <Icon name="print" /> Imprimir
        </Button>
        <Button basic onClick={onDownload}>
          <Icon name="file pdf outline" /> Descargar PDF
        </Button>
        <Button primary onClick={onFinish}>
          Listo
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
